var render = function render(){var _vm=this,_c=_vm._self._c;return _c('baseEdit',{attrs:{"canEdit":false,"disabledBusinessType":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }